import api from "./api";

/**
 * Consulta o consumo e custos do WhatsApp Business Oficial (Meta API)
 * @param {Object} params - { whatsappId, startDate, endDate, refresh }
 * @returns {Promise<Object>} Dados consolidados de consumo e custos
 */
export const getWhatsAppConsumption = async (params = {}) => {
  const { data } = await api.get("/whatsapp-consumption", {
    params
  });
  return data;
};

export default getWhatsAppConsumption;
